export enum BuyForType {
  Self = 'Self',
  Family = 'Other'
}
